import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { AxiosClient } from '../Utils/AxiosClient';
import { loginSuccess } from '../Redux/authSlice';
import { ArrowRightIcon, PrimaryButton, TextInput, VistraLogo } from '@tricor-digital-team/vistra-design-system';
import bg from '../Images/background.jpg';
import { useNavigate } from 'react-router-dom';


function getLocation() {
  if (navigator.geolocation) {
    navigator.permissions.query({ name: 'geolocation' }).then(permissionStatus => {
      if (permissionStatus.state === 'denied') {
        // alert('Please allow location access.');
        // window.location.href = "app-settings:location";
      } else {
        console.log('Permission granted');
      }
    });
  }
}

const LoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [otp, setOTP] = useState('');
  const [error, setError] = useState('');
  const [isOTPStep, setOTPStep] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  getLocation();

  const handleLogin = async (e) => {
    // navigate('/dashboard');
    setIsLoading(true);
    let payload = { username, password }
    let url = '/login-admin'
    if (isOTPStep) {
      url = '/vot'
      payload = { username, otp }
    }

    navigator.geolocation.getCurrentPosition(pos => {
      payload.latitude = pos.coords.latitude;
      payload.longitude = pos.coords.longitude;
    });

    setError('');
    e.preventDefault();
    await AxiosClient.post(url, payload)
      .then((response) => {
        if (isOTPStep || response.data?.message === 'Login successful') {
          dispatch(loginSuccess({ user: response.data?.name || username, token: response.headers.authorization }));
          navigate('/dashboard');
          return;
        }
        setOTPStep(true);
      })
      .catch((error) => {
        setError(error?.message || 'Invalid login credentials');
      }).finally(() => {
        setIsLoading(false);
      }
      );
  };


  return (
    <div className="flex h-screen bg-gray-100">
      {/* Left Side */}
      <div className="w-1/2 bg-cover bg-center flex items-center justify-center relative">
        <img alt="Background" className="absolute inset-0 w-full h-full" src={bg} />
        <div className="z-10 flex items-center w-full h-full px-[60px]">
          <h1 className="font-normal text-white">
            <VistraLogo reversed className="w-auto h-8 mb-6" />
            <span className="text-3xl">ECCTA compliance</span>
          </h1>
        </div>
      </div>

      {/* Right Side */}
      <div className="w-1/2 flex items-center justify-center bg-white">
        <nav className="px-24 py-6 fixed top-0 right-0 w-1/2 z-10">
          <div className="container pt-1 mx-auto flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <VistraLogo extraClass="h-6" />
            </div>
            {/* <div className="z-20">
              <DropdownMenu
                items={[
                  {
                    type: 'action',
                    title: 'English',
                  },
                  {
                    type: 'action',
                    title: '简体中文',
                  },
                  {
                    type: 'action',
                    title: '繁體中文',
                  },
                ]}
                menuButton={IconBtn}
              />
            </div> */}
          </div>
        </nav>
        <div className="w-full px-24">
          <div>
            {
              !isOTPStep ? <>
                <div className="flex flex-col gap-6 mb-[40px]">
                  <TextInput
                    id="userId"
                    isRequired
                    labelText="User ID"
                    placeholder="Enter your email"
                    defaultValue={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                  <TextInput
                    id="password"
                    isRequired
                    labelText="Password"
                    placeholder="Enter your password"
                    defaultValue={password}
                    type="password"
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  {error && <div class="text-red-600"> <span>Invalid User Details</span> </div>}
                </div>
              </> :
                <div className="flex flex-col gap-6 mb-[40px]">
                  <TextInput
                    id="otp"
                    isRequired
                    labelText="OTP"
                    placeholder="Please enter the OTP sent to your email."
                    maxLength={6}
                    inputMode="numeric"
                    pattern="\d*"
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d{0,6}$/.test(value)) {
                        setOTP(value);
                      }
                    }}
                  />
                  {error && <div class="text-red-600"> <span>Invalid OTP</span> </div>}

                </div>

            }

            <PrimaryButton
              icon={ArrowRightIcon}
              extraClass="w-full"
              disabled={isLoading || (!isOTPStep && (!username || !password)) || (isOTPStep && otp.length < 6)}
              iconPosition="right"
              label="Sign in"
              onClick={(e) => {
                handleLogin(e);
              }}
              size="large"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
